import { render } from "./AccountMultiple.vue?vue&type=template&id=7a0b007f"
import script from "./AccountMultiple.vue?vue&type=script&lang=js"
export * from "./AccountMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__